import { createElement, init } from '@airwallex/components-sdk';

type DropInInstance = {
  mount: (selector: string | HTMLElement) => void | Promise<void | HTMLElement>;
  on: (
    event:
      | 'ready'
      | 'error'
      | 'cancel'
      | 'success'
      | 'clickConfirmButton'
      | 'switchMethod'
      | 'pendingVerifyAccount'
      | 'surchargeFeeChange',
    handler: (payload?: unknown) => void
  ) => void;
  destroy?: () => void;
};

type PayMessage = {
  intentId?: string;
  clientSecret?: string;
};

export function parsePayMessage(payMessage?: string) {
  if (!payMessage) {
    return null;
  }
  try {
    const parsed = JSON.parse(payMessage) as PayMessage;
    if (!parsed.intentId || !parsed.clientSecret) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export async function mountAirwallexDropIn({
  containerId,
  payMessage,
  locale,
  onReady,
  onSuccess,
  onCancel,
  onError
}: {
  containerId: string;
  payMessage?: string;
  locale: string;
  onReady?: () => void;
  onSuccess?: () => void;
  onCancel?: () => void;
  onError?: (error?: unknown) => void;
}) {
  const config = parsePayMessage(payMessage);
  if (!config) {
    throw new Error('支付參數缺失');
  }

  await init({
    env: 'prod',
    origin: window.location.origin,
    enabledElements: ['payments'],
    locale: "zh-HK",
  });

  const createDropIn = createElement as unknown as (element: string, options: Record<string, unknown>) => Promise<unknown>;
  const dropIn = (await createDropIn('dropIn', {
    intent_id: config.intentId,
    client_secret: config.clientSecret,
    currency: 'USD',
    appearance: {
      mode: 'light'
    }
  })) as unknown as DropInInstance;

  const container = document.getElementById(containerId);
  if (!container) {
    throw new Error(`支付容器不存在: ${containerId}`);
  }

  await dropIn.mount(container);

  // Airwallex latest docs require binding listeners after mount().
  dropIn.on('ready', (payload) => {
    onReady?.();
  });
  dropIn.on('success', (payload) => {
    onSuccess?.();
  });
  dropIn.on('cancel', (payload) => {
    onCancel?.();
  });
  dropIn.on('error', (error) => {
    onError?.(error);
  });


  return dropIn;
}
